import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { PersonContext } from '../../context/PersonContext'; // PersonContext를 가져옵니다.
import './account.css'; // account.css 파일을 임포트합니다.
import { isRegistNum } from '../../utils/common'; // 주민번호 유효성 검사 함수
import BANK_LIST from '../../dataset/nicepay'; // default로 import
import restapi from '../../utils/restapi'; // REST API 유틸리티를 가져옵니다.

const PersonAccount = () => {
  const { person, setPerson } = useContext(PersonContext); // PersonContext에서 setPerson을 가져옵니다.
  const [bank, setBank] = useState('');
  const [account, setAccount] = useState('');
  const [name, setName] = useState('');
  const [registNum1, setRegistNum1] = useState('');
  const [registNum2, setRegistNum2] = useState('');
  const [error, setError] = useState('');
  const [isAccountChecked, setIsAccountChecked] = useState(false); // 확인 여부 상태
  const navigate = useNavigate(); // useNavigate 훅을 사용하여 페이지 이동


  useEffect(() => {
    if(person) {
      const registNum = person.registNum ? person.registNum.split('-') : []; // 주민번호를 하이픈(-)으로 분리합니다.
      console.log('registNum:', registNum);
      if (registNum[0]) setRegistNum1(registNum[0]);
      if (registNum[1]) setRegistNum2(registNum[1]);

      if (person.data && person.data.bank) {
        setBank(person.data.bank);
      }
      if (person.data && person.data.account) {
        setAccount(person.data.account);
      }
      if (person.data && person.data.name) {
        setName(person.data.name);
      }
      if (person.data && person.data.account && person.data.bank) {
        setIsAccountChecked(true); // 계좌 정보가 있다면 확인 상태를 true로
      }
    }
  }, [person]);

  useEffect(() => {
    //if (error) alert(error);
  }, [error]);

  const handleSendAccountConfirm = async () => {
    setIsAccountChecked(false); // 인증번호 확인 상태를 초기화합니다.

    try {  
      if (await restapi.isValidBankAccount(bank, account, name)) {
        alert('정상 계좌입니다.');
        setIsAccountChecked(true);
      } else {
        alert('계좌 정보가 일치하지 않습니다. 다시 확인해주세요.');
        setIsAccountChecked(false);
      }
    } catch (error) {
      console.error('계좌조회 오류:', error);
      setError(error.message);
    }
  };

  const handleSubmit = async () => {
    setError(''); // 에러 메시지를 초기화합니다.
    if (!isAccountChecked) {
      setError('계좌 조회를 먼저 진행해주세요.');
      return;
    }

    if (!registNum1) {
      setError('주민번호 앞 6자리를 입력해주세요.');
      return;
    }

    if (!registNum2) {
      setError('주민번호 뒷 7자리를 입력해주세요.');
      return;
    }

    //주민번호 형식 검사
    if (!/^\d{6}$/.test(registNum1) || !/^\d{7}$/.test(registNum2)) {
      setError('주민번호 형식이 올바르지 않습니다. 앞 6자리와 뒷 7자리를 정확히 입력해주세요.');
      return;
    }

    // 주민번호 알고리즘에 의한 유효성 검사
    if (!isRegistNum(`${registNum1}${registNum2}`)) {
      setError('주민번호 형식이 올바르지 않습니다. 다시 확인해 주세요.');
      return;
    }

    let birth = '';
    if (registNum2.substring(0, 1) !== '1' && registNum2.substring(0, 1) !== '2') {
      birth = `19${registNum1.substring(0, 2)}-${registNum1.substring(2, 4)}-${registNum1.substring(4, 6)}`;
    }
    else if (registNum2.substring(0, 1) !== '3' && registNum2.substring(0, 1) !== '4') {
      birth = `20${registNum1.substring(0, 2)}-${registNum1.substring(2, 4)}-${registNum1.substring(4, 6)}`;
    }

    try {
      const data = {
        ...person,
        registNum: `${registNum1}-${registNum2}`, // 주민번호를 하이픈(-)으로 구분하여 저장
        birth: birth, // 주민번호 앞 6자리를 생년월일로 사용
        data: {
          ...person.data,
          bank: bank,
          account: account,
          name: name,
        }
      }

      const dataset = await restapi.person_update(person.person_id, data);
      //console.log(dataset);
      setPerson(dataset); // PersonContext의 상태를 업데이트합니다.
      alert('수당지급용 주민번호 및 계좌 정보가 저장되었습니다.');
      window.location.href = '/'; // 저장 후 홈으로 이동
    } catch (error) {
      console.error(error);
      setError(error.message);
    }
  }

  return (
    <div id="person_account">
      <div className="head">
        <h1>수당지급용계좌</h1>
      </div>
      <div className="body">
        <ul className="form">
          <li>
            <label>성명</label>
            <span>
              { person && person.name ? person.name : '' }
            </span>
          </li>
          <li>
            <label>주민번호(<b>세금신고용</b>)</label>
            <span>
              <input
                type="text"
                placeholder="주민번호 앞 6자리"
                value={registNum1}
                onChange={(e) => setRegistNum1(e.target.value)}
              /> - <input
                type="text"
                placeholder="주민번호 뒷 7자리"
                value={registNum2}
                onChange={(e) => setRegistNum2(e.target.value)}
              />
            </span>
          </li>
          <li>
            <label>은행선택</label>
            <span>
              <select
                value={bank}
                onChange={(e) => setBank(e.target.value)}
              >
                <option value="">은행을 선택하세요.</option>
                {BANK_LIST.map(b => (
                  <option key={b.code} value={b.code}>{b.name}</option>
                ))}
              </select>
            </span>
          </li>
          <li>
            <label>계좌번호</label>
            <span>
              <input
                type="text"
                placeholder="계좌번호를 입력하세요."
                value={account}
                onChange={(e) => setAccount(e.target.value)}
              />
            </span>
          </li>
          <li>
            <label>예금주</label>
            <span>
              <input
                type="text"
                placeholder="예금주를 입력하세요."
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="name"
              />
              <button onClick={handleSendAccountConfirm}>계좌조회</button>
            </span>
          </li>
        </ul>
        {error && <div className="error">{error}</div>}
        <div>
          <button className="submit" onClick={handleSubmit} disabled={!isAccountChecked}>저장하기</button>
          <button onClick={() => navigate('/')}>이전페이지로</button>
        </div>
      </div>
    </div>
  );
};

export default PersonAccount;
